import { Component } from "react";
import { triggerEvent, wvusLogger } from "../../helpers";
import { getPhrase, PhraseKey } from "../../languages";

// When passing in a value for children, also pass a matching value for message
// so analytics and logging match what the user sees.
type AppErrorPropsType = {
  error?: Error;
  message?: string;
  children?: JSX.Element;
};

export default class AppError extends Component<AppErrorPropsType> {
  constructor(props: AppErrorPropsType) {
    super(props);
  }

  render() {
    const defaultPhraseKey = "errors.general_error_volunteer";
    const defaultErrorMessage =
      "An error has occurred. Please try again, and if the problem persists, refresh the page or ask a volunteer for help.";
    let phraseKey = defaultPhraseKey;
    let errorMessage = defaultErrorMessage;

    try {
      if (this.props?.message) {
        phraseKey = `${this.props?.message}:dynamic`;
        errorMessage = this.props?.message;
      } else {
        errorMessage = getPhrase(phraseKey as PhraseKey) || defaultErrorMessage;
      }

      const errorDetail = this.props?.error?.message || "Unknown error occurred";
      wvusLogger.log(errorDetail, wvusLogger.getLogLevelNames().CRITICAL);
      console.log({ error: errorDetail });

      triggerEvent("error_view", {
        error_message: errorMessage,
        error_type: "app_error",
        event_label: errorDetail
      });
    } catch (e) {
      console.log(e);
      phraseKey = defaultPhraseKey;
      errorMessage = defaultErrorMessage;
    }

    const messageElement = this.props?.children || (
      <p>
        <i className="fa fa-times-circle" aria-hidden="true"></i>{" "}
        <span data-phrase-key={phraseKey}>{errorMessage}</span>
      </p>
    );

    // TODO: Include Error Message HTML and Styles
    return (
      <div className="App AppError" style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>{" "}
          {messageElement}
        </div>
      </div>
    );
  }
}
